/* Maa: Hero slideshow
   Cross-fades the hero photograph and keeps the name/link caption below it in
   step with the slide on screen. Vanilla, no dependencies.
   Autoplay is gated on the data-autoplay attribute, a slide count above one,
   and prefers-reduced-motion. Pauses on hover/focus and inside the editor. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.maHeroInit === '1') return;
    root.dataset.maHeroInit = '1';

    var slides = Array.prototype.slice.call(root.querySelectorAll('.hero-slide'));
    var count = slides.length;
    if (count < 1) return;

    var showDots = root.getAttribute('data-dots') !== 'false';
    var motion = window.matchMedia
      ? window.matchMedia('(prefers-reduced-motion: reduce)')
      : { matches: false };
    var autoplay =
      root.getAttribute('data-autoplay') === 'true' && count > 1 && !motion.matches;
    var seconds = parseInt(root.getAttribute('data-speed'), 10) || 5;

    var capTitle = document.querySelector('[data-hero-cap-title]');
    var capLink = document.querySelector('[data-hero-cap-link]');
    var dots = [];

    if (showDots && count > 1) {
      var bar = document.createElement('div');
      bar.className = 'hero-dots';
      bar.setAttribute('role', 'group');
      bar.setAttribute('aria-label', 'Choose slide');
      slides.forEach(function (slide, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'hero-dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('data-slide', String(i));
        dot.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        dot.setAttribute(
          'aria-label',
          'Slide ' + (i + 1) + ' of ' + count + ': ' + (slide.dataset.title || '')
        );
        bar.appendChild(dot);
        dots.push(dot);
      });
      root.appendChild(bar);
    }

    var index = 0;
    var timer = null;

    function paint() {
      slides.forEach(function (slide, i) {
        var on = i === index;
        slide.classList.toggle('is-active', on);
        slide.setAttribute('aria-hidden', on ? 'false' : 'true');
        // Keep hidden slides out of the tab order.
        if (on) {
          slide.removeAttribute('tabindex');
        } else {
          slide.setAttribute('tabindex', '-1');
        }
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-selected', i === index ? 'true' : 'false');
      });

      var active = slides[index];
      if (capTitle && active) capTitle.textContent = active.dataset.title || '';
      if (capLink && active) capLink.setAttribute('href', active.dataset.url || '#');
    }

    function goTo(i) {
      index = ((i % count) + count) % count;
      paint();
      restart();
    }

    function next() {
      goTo(index + 1);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function restart() {
      stop();
      if (autoplay) timer = window.setInterval(next, seconds * 1000);
    }

    if (dots.length) {
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          goTo(parseInt(dot.getAttribute('data-slide'), 10) || 0);
        });
      });
    }

    if (autoplay) {
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', restart);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', restart);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          stop();
        } else {
          restart();
        }
      });
      restart();
    }

    // Touch swipe, same 40px threshold the theme's other slideshows use.
    var touchX = null;
    root.addEventListener(
      'touchstart',
      function (e) {
        touchX = e.touches[0].clientX;
      },
      { passive: true }
    );
    root.addEventListener(
      'touchend',
      function (e) {
        if (touchX === null) return;
        var dx = e.changedTouches[0].clientX - touchX;
        touchX = null;
        if (Math.abs(dx) > 40 && count > 1) next();
      },
      { passive: true }
    );

    // Rotating while the merchant drags a block is just noise.
    document.addEventListener('shopify:section:load', function () {
      stop();
    });

    if (motion.addEventListener) {
      motion.addEventListener('change', function () {
        autoplay = false;
        stop();
      });
    }

    paint();
  }

  function boot() {
    Array.prototype.slice
      .call(document.querySelectorAll('[data-hero-slides]'))
      .forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();